export default __webpack_public_path__ + "static/media/bank-account.b4c24f67.png";